import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getCompanies = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/companies/?limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const getAllCompanies = async () => {
  const response = await api.get(
    `api/v1/companies/?limit=999/`
  );
  return response.data;
};

export const getCompanyById = async (companyId) => {
  const response = await api.get(`api/v1/companies/${companyId}/`);
  return response.data;
};

export const createCompany = async (payload) => {
  const response = await api.post(
    "api/v1/companies/",
    payload
  );
  return response.data;
};

export const updateCompany = async (companyId, payload) => {
  const response = await api.patch(
    `api/v1/companies/${companyId}/`,
    payload
  );
  return response.data;
};


export const deleteCompany = async (companyId) => {
  await api.delete(`api/v1/companies/${companyId}/`);
};


